import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

import { useAppStore } from '@/stores/AppStore';
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import ThemeSwitcher from './ThemeSwitcher.vue';
import { useDisplay } from 'vuetify';
import { AuthService, User } from "@/services/auth/authService"


export default /*#__PURE__*/_defineComponent({
  __name: 'AppBar',
  setup(__props) {

const appStore = useAppStore();
const router = useRouter();

const display = useDisplay()
const showingDrawer = ref(!display.sm.value)

const authService = new AuthService()
const currentUser = ref<User>()

const menuItems = [
    { prependIcon: "mdi-plus", title: "Comenzar encuesta", routeName: "home" },
]

const menuFooterItems = [
    { prependIcon: "mdi-download", title: "Descargar resultados", routeName: "download-results", disabled: false, onlyAdmin: true },
    { prependIcon: "mdi-file", title: "Encuestas", routeName: "surveys", disabled: false, onlyAdmin: true },
    { prependIcon: "mdi-account", title: "Usuarios", routeName: "users", disabled: false, onlyAdmin: true },
    { prependIcon: "mdi-login", title: "Cerrar sesión", routeName: "login", disabled: false },
]

function isCurrentRoute(routeName: string) {
    return router.currentRoute.value.name === routeName;
}

function goTo(routeName: string) {
    router.push({name: routeName});
}

onMounted(() => {
    currentUser.value = authService.getCurrentUser() 
})


return (_ctx: any,_cache: any) => {
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_app_bar_title = _resolveComponent("v-app-bar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!showingDrawer.value)
      ? (_openBlock(), _createBlock(_component_v_app_bar, {
          key: 0,
          density: "compact",
          "scroll-behavior": "collapse",
          elevation: "0"
        }, {
          prepend: _withCtx(() => [
            _createVNode(_component_v_app_bar_nav_icon, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showingDrawer.value = !showingDrawer.value))
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_v_app_bar_title, null, {
              default: _withCtx(() => [
                _createTextVNode(" EOD Vehículos ")
              ]),
              _: 1
            }),
            _createVNode(_component_v_spacer),
            (_unref(appStore).inOfflineMode)
              ? (_openBlock(), _createBlock(_component_v_chip, {
                  key: 0,
                  density: "compact",
                  "prepend-icon": "mdi-wifi-off",
                  color: "warning"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Sin Conexión ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(ThemeSwitcher)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_v_navigation_drawer, {
      modelValue: showingDrawer.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showingDrawer).value = $event)),
      fixed: "",
      width: "300",
      "mobile-breakpoint": "md",
      temporary: false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_list, {
          class: "h-100 d-flex flex-column",
          nav: "",
          density: "compact"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_list_item, {
              title: "EOD Vehículos",
              subtitle: "Sistema de encuestas"
            }),
            _createVNode(_component_v_divider),
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menuItems, (item) => {
              return _createVNode(_component_v_list_item, {
                active: isCurrentRoute(item.routeName),
                key: item.title,
                title: item.title,
                "prepend-icon": item.prependIcon,
                onClick: ($event: any) => (goTo(item.routeName)),
                color: "primary"
              }, null, 8, ["active", "title", "prepend-icon", "onClick"])
            }), 64)),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_spacer),
            (_unref(appStore).inOfflineMode)
              ? (_openBlock(), _createBlock(_component_v_alert, {
                  key: 0,
                  class: "flex-0-0",
                  density: "compact",
                  color: "warning",
                  variant: "tonal",
                  title: "Modo sin conexión",
                  border: "start",
                  text: "La aplicación está trabajando sin conexión. Las encuestas realizadas se guardar en la memoria del dispositivo. Una vez se establezca nuevamente la conexión, se enviaran los datos al servidor."
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_list, {
              nav: "",
              density: "compact"
            }, {
              default: _withCtx(() => [
                _createVNode(ThemeSwitcher, { "as-list-item": "" }),
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menuFooterItems, (item) => {
                  return _withDirectives(_createVNode(_component_v_list_item, {
                    active: isCurrentRoute(item.routeName),
                    key: item.title,
                    title: item.title,
                    "prepend-icon": item.prependIcon,
                    onClick: ($event: any) => (goTo(item.routeName)),
                    color: "primary",
                    disabled: item.disabled
                  }, null, 8, ["active", "title", "prepend-icon", "onClick", "disabled"]), [
                    [_vShow, !item.onlyAdmin || currentUser.value?.isAdmin]
                  ])
                }), 64))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})